<template>
<ItpPage
  no-primary-button
  :closeButtonText="'Close'|gettext"
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="ContractTermEditor"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      name="contract"
      class="row"
      ref="mainForm"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpCol>
        <ItpFormGroup
          name="service"
          :label="'Service'|pgettext('ContractTerm')"
          labelColsMd="4"
          contentColsMd="8"
          :labelAlign="labelAlign"
          v-if="!isTermReadonly"
        >
          <ItpFormSelect2
            name="client"
            v-model="item.service"
            bind-object
            :dataSource="b_5731695935601903_dataSource"
            textField="name"
            @optionSelected="evh_5731695935601903_optionSelected($event, {})"
          >
          </ItpFormSelect2>
        </ItpFormGroup>
        <ItpFormGroup
          name="name"
          :label="'Name'|pgettext('ContractTerm')"
          labelColsMd="4"
          contentColsMd="8"
          :labelAlign="labelAlign"
        >
          <ItpFormInput
            name="name"
            v-model="item.name"
            required
            :readonly="isTermReadonly"
          >
          </ItpFormInput>
        </ItpFormGroup>
        <ItpFormGroup
          name="valid_from"
          :label="'Valid from'|pgettext('ContractTerm')"
          labelColsMd="4"
          contentColsMd="4"
          :labelAlign="labelAlign"
        >
          <ItpFormDatetime
            name="valid_from"
            v-model="item.valid_from"
            :readonly="isTermReadonly"
          >
          </ItpFormDatetime>
        </ItpFormGroup>
        <ItpFormGroup
          name="valid_to"
          :label="'Valid to'|pgettext('ContractTerm')"
          labelColsMd="4"
          contentColsMd="4"
          :labelAlign="labelAlign"
        >
          <ItpFormDatetime
            name="valid_to"
            v-model="item.valid_to"
            :readonly="isTermReadonly"
          >
          </ItpFormDatetime>
        </ItpFormGroup>
        <hr>
        </hr>
        <ItpFormGroup
          :label="'Amount'|pgettext('ContractTerm')"
          labelColsMd="4"
          contentColsMd="8"
          :labelAlign="labelAlign"
          contentClass="input-group"
        >
          <ItpFormInput
            type="number"
            name="amount"
            v-model="item.amount"
            class="col-8"
          >
          </ItpFormInput>
          <ItpFormSelect
            name="currency"
            v-model="item.currency"
            :options="currencies"
            textField="code"
            valueField="code"
            class="col-4"
          >
          </ItpFormSelect>
        </ItpFormGroup>
        <ItpFormGroup
          name="quantity"
          :label="'Quantity'|pgettext('ContractTerm')"
          labelColsMd="4"
          contentColsMd="4"
          :labelAlign="labelAlign"
          contentClass="input-group"
        >
          <ItpFormInput
            type="number"
            name="quantity"
            v-model="item.quantity"
          >
          </ItpFormInput>
        </ItpFormGroup>
        <ItpFormGroup
          name="unit"
          :label="'Unit'|pgettext('ContractTerm')"
          labelColsMd="4"
          contentColsMd="4"
          :labelAlign="labelAlign"
          contentClass="input-group"
        >
          <ItpFormInput
            name="unit"
            v-model="item.unit"
          >
          </ItpFormInput>
        </ItpFormGroup>
        <ItpFormGroup
          name="notes"
          :label="'Notes'|pgettext('ContractTerm')"
          labelColsMd="4"
          contentColsMd="8"
          :labelAlign="labelAlign"
        >
          <ItpFormTextarea
            name="notes"
            v-model="item.notes"
          >
          </ItpFormTextarea>
        </ItpFormGroup>
      </ItpCol>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Delete Term'|pgettext('Button')"
      variant="danger"
      icon="fa-times"
      :spinning="actions.delete && actions.delete.isRunning"
      class="mr-auto"
      v-if="mode === 'edit' && isDeletable"
      @click.prevent.stop="evh_1548630417156826_clickPreventStop($event, {})"
    >
    </ItpButton>
    <ItpButton
      :text="'Save'|pgettext('Button')"
      :disabled="!forms.contract || !forms.contract.submittable"
      type="submit"
      :form="formId"
      variant="primary"
      icon="fa-save"
      :spinning="actions.save && actions.save.isRunning"
      v-if="isEditable"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      @click.prevent.stop="evh_2186679009640457_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class ContractTermEditor extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  getConfiguration(...args: any[]) {
    switch (this.mode) {

      case 'add':
        return {
          isEditable: true,
          isDeletable: false,
          isTermReadonly: false,
        };

      case 'edit':
        return {
          isEditable: !this.term.locked,
          isDeletable: !this.term.locked,
          isTermReadonly: this.term.locked,
        };
    }
  }

  @Prop({
    required: true,
    type: Object,
  })
  contract!: object;

  @Watch('contract')
  onContract(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("contract")
  }

  @Prop({
    type: Object,
  })
  term!: object;

  @Watch('term')
  onTerm(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("term")
  }

  @Prop({
    required: true,
    type: String,
  })
  mode!: string;

  @Watch('mode')
  onMode(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("mode")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  labelAlign!: any;
  isEditable!: any;

  async $$load_isEditable() {
    return this.getConfiguration().isEditable
  }

  isDeletable!: any;

  async $$load_isDeletable() {
    return this.getConfiguration().isDeletable
  }

  isTermReadonly!: any;

  async $$load_isTermReadonly() {
    return this.getConfiguration().isTermReadonly
  }

  messages!: any;
  item!: any;

  async $$load_item() {
    return this.term || this.$fn.schemaDefaults('CreateContractTerm', {
      contract_id: this.contract.id
    })
  }

  currencies!: any;

  async $$load_currencies() {
    return this.$fn.fetch('list_currency')
  }

  services!: any;

  async $$load_services() {
    return this.$fn.fetch('suggest_product', {
      parameters: { query: '*', top: 50, skip: 0 }
    }).then(data => _.orderBy(data, [p => p.name.toLowerCase()]))
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_5731695935601903_dataSource!: any;
  dataMembers = ['formId', 'labelAlign', 'isEditable', 'isDeletable', 'isTermReadonly', 'messages', 'item', 'currencies', 'services', 'ux', 'b_7315092382398562_modalBindings', 'b_5731695935601903_dataSource'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        formId: null,
        labelAlign: "right",
        isEditable: null,
        isDeletable: null,
        isTermReadonly: null,
        messages: {
          add: {
            title: this.$fn.pgettext("Contract|ModalHeader", "Add term"),
          }
          ,
          edit: {
            title: this.$fn.pgettext("Contract|ModalHeader", "Edit term"),
          }
          ,
        }
        ,
        item: null,
        currencies: null,
        services: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          noPrimaryButton: true,
          closeButtonText: this.$fn.gettext("Close"),
          size: "md",
        }
        ,
        b_5731695935601903_dataSource: {
          name: "suggest_product",
        }
        ,
      },
    }
  }

  get currentObjectType() {
    if (this.loaded) {

      return "contract_term"
    }
    return null;
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.messages[this.mode].title,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_8956_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_8956, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeModal_8962_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1040167445267876_closeModal_8962, alias=undefined
    return {
      result: {
        ok: true,
        value: $event.data,
      }
      ,
    }
  }

  async act_1040167445267876_crud_8960_getActionArgs($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_1040167445267876_crud_8960, alias=save
    return {
      objectType: this.currentObjectType,
      op: "upsert",
      data: this.item,
      options: {
        parameters: {
          rev: this.contract.revision_number,
        }
        ,
      }
      ,
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_5731695935601903_setData_8964_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_5731695935601903_setData_8964, alias=undefined
    return {
      path: "item.name",
      value: $event.data.option.name,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_5731695935601903_setData_8966_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_5731695935601903_setData_8966, alias=undefined
    return {
      path: "item.service_id",
      value: $event.data.option.id,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_5731695935601903_setData_8968_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_5731695935601903_setData_8968, alias=undefined
    return {
      path: "item.unit",
      value: $event.data.option.unit,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_5731695935601903_optionSelected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5731695935601903_optionSelected.executeFromDOM(this, event, scope);
  }

  async act_1548630417156826_closeModal_8972_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1548630417156826_closeModal_8972, alias=undefined
    return {
      result: {
        ok: true,
      }
      ,
    }
  }

  async act_1548630417156826_request_8970_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1548630417156826_request_8970, alias=deleteTerm
    return {
      operation: "delete_contract_term",
      data: this.item,
    }
  }

  async evh_1548630417156826_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async evh_2186679009640457_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2186679009640457_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_8956: actions.CloseModalAction;
    evh_7315092382398562_close_8955: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_8958: actions.CloseComponentAction;
    evh_2248226175642056_close_8957: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeModal_8962: actions.CloseModalAction;
    evh_1040167445267876_success_8961: actions.EventHandlerImpl;
    act_1040167445267876_crud_8960: actions.CRUDAction;
    evh_1040167445267876_submit_8959: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_5731695935601903_setData_8964: actions.SetDataAction;
    evh_5731695935601903_optionSelected_8963: actions.EventHandlerImpl;
    act_5731695935601903_setData_8966: actions.SetDataAction;
    evh_5731695935601903_optionSelected_8965: actions.EventHandlerImpl;
    act_5731695935601903_setData_8968: actions.SetDataAction;
    evh_5731695935601903_optionSelected_8967: actions.EventHandlerImpl;
    evh_5731695935601903_optionSelected: actions.EventHandlerGroup;
    act_1548630417156826_closeModal_8972: actions.CloseModalAction;
    evh_1548630417156826_success_8971: actions.EventHandlerImpl;
    act_1548630417156826_request_8970: actions.RequestAction;
    evh_1548630417156826_clickPreventStop_8969: actions.EventHandlerImpl;
    evh_1548630417156826_clickPreventStop: actions.EventHandlerGroup;
    act_2186679009640457_closeComponent_8974: actions.CloseComponentAction;
    evh_2186679009640457_clickPreventStop_8973: actions.EventHandlerImpl;
    evh_2186679009640457_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_8956 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_8956_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_8955 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_8956,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_8955],
      }
    );
    const act_2248226175642056_closeComponent_8958 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_8957 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_8958,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_8957],
      }
    );
    const act_1040167445267876_closeModal_8962 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1040167445267876_closeModal_8962_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_8961 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeModal_8962,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1040167445267876_crud_8960 = new actions.CRUDAction(
      {
        actionArgs: this.act_1040167445267876_crud_8960_getActionArgs,
        displayName: "save",
        events: [evh_1040167445267876_success_8961],
      }
    );
    const evh_1040167445267876_submit_8959 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_crud_8960,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_8959],
      }
    );
    const act_5731695935601903_setData_8964 = new actions.SetDataAction(
      {
        actionArgs: this.act_5731695935601903_setData_8964_getActionArgs,
        events: [],
      }
    );
    const evh_5731695935601903_optionSelected_8963 = new actions.EventHandlerImpl(
      {
        action: act_5731695935601903_setData_8964,
        event: "optionSelected",
        displayName: "setData",
      }
    );
    const act_5731695935601903_setData_8966 = new actions.SetDataAction(
      {
        actionArgs: this.act_5731695935601903_setData_8966_getActionArgs,
        events: [],
      }
    );
    const evh_5731695935601903_optionSelected_8965 = new actions.EventHandlerImpl(
      {
        action: act_5731695935601903_setData_8966,
        event: "optionSelected",
        displayName: "setData",
      }
    );
    const act_5731695935601903_setData_8968 = new actions.SetDataAction(
      {
        actionArgs: this.act_5731695935601903_setData_8968_getActionArgs,
        events: [],
      }
    );
    const evh_5731695935601903_optionSelected_8967 = new actions.EventHandlerImpl(
      {
        action: act_5731695935601903_setData_8968,
        event: "optionSelected",
        displayName: "setData",
      }
    );
    const evh_5731695935601903_optionSelected = new actions.EventHandlerGroup(
      {
        handlers: [evh_5731695935601903_optionSelected_8963, evh_5731695935601903_optionSelected_8965, evh_5731695935601903_optionSelected_8967],
      }
    );
    const act_1548630417156826_closeModal_8972 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1548630417156826_closeModal_8972_getActionArgs,
        events: [],
      }
    );
    const evh_1548630417156826_success_8971 = new actions.EventHandlerImpl(
      {
        action: act_1548630417156826_closeModal_8972,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1548630417156826_request_8970 = new actions.RequestAction(
      {
        actionArgs: this.act_1548630417156826_request_8970_getActionArgs,
        displayName: "deleteTerm",
        events: [evh_1548630417156826_success_8971],
      }
    );
    const evh_1548630417156826_clickPreventStop_8969 = new actions.EventHandlerImpl(
      {
        action: act_1548630417156826_request_8970,
        event: "click.prevent.stop",
        displayName: "deleteTerm",
      }
    );
    const evh_1548630417156826_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1548630417156826_clickPreventStop_8969],
      }
    );
    const act_2186679009640457_closeComponent_8974 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2186679009640457_clickPreventStop_8973 = new actions.EventHandlerImpl(
      {
        action: act_2186679009640457_closeComponent_8974,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_2186679009640457_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2186679009640457_clickPreventStop_8973],
      }
    );
    return {
      act_7315092382398562_closeModal_8956,
      evh_7315092382398562_close_8955,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_8958,
      evh_2248226175642056_close_8957,
      evh_2248226175642056_close,
      act_1040167445267876_closeModal_8962,
      evh_1040167445267876_success_8961,
      act_1040167445267876_crud_8960,
      evh_1040167445267876_submit_8959,
      evh_1040167445267876_submit,
      act_5731695935601903_setData_8964,
      evh_5731695935601903_optionSelected_8963,
      act_5731695935601903_setData_8966,
      evh_5731695935601903_optionSelected_8965,
      act_5731695935601903_setData_8968,
      evh_5731695935601903_optionSelected_8967,
      evh_5731695935601903_optionSelected,
      act_1548630417156826_closeModal_8972,
      evh_1548630417156826_success_8971,
      act_1548630417156826_request_8970,
      evh_1548630417156826_clickPreventStop_8969,
      evh_1548630417156826_clickPreventStop,
      act_2186679009640457_closeComponent_8974,
      evh_2186679009640457_clickPreventStop_8973,
      evh_2186679009640457_clickPreventStop,
      save: act_1040167445267876_crud_8960,
      deleteTerm: act_1548630417156826_request_8970,
    }
  }
}

Vue.component("ContractTermEditor", ContractTermEditor);

</script>